module.exports = __webpack_public_path__ + "static/media/Ringing.e0f88060.wav";